// extracted by mini-css-extract-plugin
export default {"root":"CookieNotice_root__9xPri","layout-container":"CookieNotice_layout-container__GvDZd","cookieContainer":"CookieNotice_cookieContainer__B61RJ","description":"CookieNotice_description__ieKrX","hightLight":"CookieNotice_hightLight__sNbfe","hintText":"CookieNotice_hintText__dHYiy","actionsContainer":"CookieNotice_actionsContainer__xGXVu","primaryButton":"CookieNotice_primaryButton__sZCjL","button":"CookieNotice_button__L7edI"};
    if(module.hot) {
      // 1763464084278
      var cssReload = require("/usr/src/app/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  